import React, { FC, useEffect, useState } from 'react'
import { endOfMonth, endOfWeek, format, startOfMonth, startOfWeek } from '../../../../utils/date'
import { clone } from 'lodash'
import Holidays from 'date-holidays'

interface Props {
  targetYear: number
  targetMonth: number
  holidayList: string[]
  submitCallback: (holidayList: string[]) => void
  isSubmit: boolean
  isClear: boolean
  quickChange: string
}

const MonthlyCalendar: FC<Props> = (props) => {
  const {
    targetYear,
    targetMonth,
    holidayList,
    submitCallback,
    isSubmit,
    isClear,
    quickChange,
  } = props

  const holidays = new Holidays()
  holidays.init('JP')

  const [tmpHolidayList, setTmpHolidayList] = useState<string[]>([])

  const calendarColor = (day: string) => {
    if (Number.isNaN(new Date(day).getTime())) return "#666666"
    const holiday = holidays.isHoliday(new Date(day))
    if ((holiday && holiday[0].type === "public") || format(day, 'd') === '0') {
      return "#FF0000"
    }
    if (format(day, 'd') === '6') {
      return "#317AB7"
    }
    return "#666666"
  }

  const changeHoliday = (targetDate: string) => {
    if (!tmpHolidayList.length) {
      setTmpHolidayList([targetDate])
      return
    }
    if (tmpHolidayList?.includes(targetDate)) {
      setTmpHolidayList((cur) => cur.filter((w) => w !== targetDate))
    } else {
      setTmpHolidayList((cur) => [...cur, targetDate])
    }
  }

  const clearHolidayList = () => {
    setTmpHolidayList((cur) => cur.filter((v) => Number(format(v, "YYYY")) !== targetYear))
  }

  const quickHolidaySetting = (type: string) => {
    const targeYMD = `${targetYear}/${targetMonth}/01`
    const dateList: string[] = []
    for (let d = clone(new Date(startOfMonth(targeYMD)));d <= new Date(endOfMonth(targeYMD));d.setDate(d.getDate() + 1)) {
      const holiday = holidays.isHoliday(d)
      if (type === "sss" && (d.getDay() === 0 || d.getDay() === 6 || (holiday && holiday[0]?.type === "public"))) {
        dateList.push(format(d, "YYYY-MM-DD"))
      }
      if (type === "sun" && d.getDay() === 0) {
        dateList.push(format(d, "YYYY-MM-DD"))
      }
      if (type === "mon" && d.getDay() === 1) {
        dateList.push(format(d, "YYYY-MM-DD"))
      }
      if (type === "tue" && d.getDay() === 2) {
        dateList.push(format(d, "YYYY-MM-DD"))
      }
      if (type === "wed" && d.getDay() === 3) {
        dateList.push(format(d, "YYYY-MM-DD"))
      }
      if (type === "thu" && d.getDay() === 4) {
        dateList.push(format(d, "YYYY-MM-DD"))
      }
      if (type === "fri" && d.getDay() === 5) {
        dateList.push(format(d, "YYYY-MM-DD"))
      }
      if (type === "sat" && d.getDay() === 6) {
        dateList.push(format(d, "YYYY-MM-DD"))
      }
      if (type === "holiday" && holiday && holiday[0]?.type === "public") {
        dateList.push(format(d, "YYYY-MM-DD"))
      }
    }
    setTmpHolidayList((cur) => Array.from(new Set([...cur, ...dateList])))
  }

  const buildCalendar = () => {
    const targeYMD = `${targetYear}/${targetMonth}/01`
    const monthFirstWeekDay = startOfWeek(startOfMonth(targeYMD))
    const monthLastWeekDay = endOfWeek(endOfMonth(targeYMD))
    let dateList = []
    for (let d = clone(new Date(monthFirstWeekDay));d <= new Date(monthLastWeekDay);d.setDate(d.getDate() + 1)) {
      dateList.push(format(d, "YYYY-MM-DD"))
    }
    dateList = Array.from(new Set(dateList))
    return (
      <div
        className="calendar_box"
        style={{
          position: "relative",
          top: "unset",
          right: "unset",
          boxShadow: "none",
          border: "solid 1px #CCCCCC",
          width: "calc(25% - 6px)",
          padding: 0,
        }}
      >
        <div
          className="daily"
          style={{
            width: "100%",
          }}
        >
          <div
            className="select_month"
            style={{
              justifyContent: "center",
            }}
          >
            <div>
              {`${targetYear}年${targetMonth}月`}
            </div>
          </div>
          <div className="date_wrap">
            {
              dateList.map((v) => (
                <React.Fragment key={`${targetYear}_${targetMonth}_${v}`}>
                  {
                    format(v, "MM") === format(targeYMD, "MM") ? (
                      <div
                        className="date"
                        style={{
                          color: calendarColor(v),
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: "8px 0",
                          position: "relative",
                        }}
                        role="none"
                        onClick={() => changeHoliday(v)}
                      >
                        {format(v, "D")}
                        <div
                          style={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            backgroundColor: "#FF0000",
                            width: "24px",
                            height: "24px",
                            borderRadius: "50%",
                            transform: "translate(-50%, -50%)",
                            opacity: tmpHolidayList?.includes(v) ? "0.2" : "0",
                            transition: "50ms",
                          }}
                        />
                      </div>
                    ) : (
                      <div
                        className="date disable"
                        style={{
                          color: calendarColor(v),
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: "8px 0",
                        }}
                      >
                        {format(v, "D")}
                      </div>
                    )
                  }
                </React.Fragment>
              ))
            }
          </div>
        </div>
      </div>
    )
  }

  useEffect(() => {
    setTmpHolidayList(holidayList)
  }, [holidayList])

  useEffect(() => {
    if (!isSubmit) return
    submitCallback(tmpHolidayList)
  }, [isSubmit])

  useEffect(() => {
    if (!isClear) return
    clearHolidayList()
  }, [isClear])

  useEffect(() => {
    if (!quickChange.length) return
    quickHolidaySetting(quickChange)
  }, [quickChange])

  return (
    <>
      <React.Fragment key={`${targetYear}_${targetMonth}`}>
        {buildCalendar()}
      </React.Fragment>
    </>
  )
}

export default MonthlyCalendar
